module.exports = __webpack_public_path__ + "static/assets/74546102be38f592d24b4330a16a8639.svg";